export interface CheckoutStep {
  id: string;
  routeName: string;
  required: boolean;
}

export interface CustomCheckoutConfig {
  [mode: string]: {
    steps: CheckoutStep[];
  };
}

export const customCheckoutConfig: CustomCheckoutConfig = {
  pickUp: {
    steps: [
      { id: 'person', routeName: 'checkout/pickup-person', required: true },
      { id: 'store', routeName: 'checkout/pickup-store', required: true },
      { id: 'payment', routeName: 'checkout/payment', required: true }
    ]
  },
  delivery: {
    steps: [
      { id: 'address', routeName: 'checkout/delivery-address', required: true },
      { id: 'schedule', routeName: 'checkout/schedule-delivery', required: true },
      { id: 'instructions', routeName: 'checkout/delivery-instructions', required: false },
      { id: 'payment', routeName: 'checkout/payment', required: true }
    ]
  }
};

// use this during form submission
// const currentMode = this.checkoutFlowService.getMode();
//     this.checkoutFlowService.markCompleted(currentMode, 'checkout/pickup-person');